"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChapterWithContentResponseModelState = void 0;
exports.ChapterWithContentResponseModelState = {
    Default: "default",
    Converting: "converting",
};
